var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { ThemeProvider } from "styled-components";
import ErrorBoundary from "components/error_boundary";
import THEME from "theme";
var renderIntoApp = function (Component, props) {
    if (props === void 0) { props = {}; }
    ReactDOM.render(React.createElement(AppContainer, null,
        React.createElement(ThemeProvider, { theme: THEME },
            React.createElement(ErrorBoundary, null,
                React.createElement(Component, __assign({}, props))))), document.getElementById("root"));
};
export default renderIntoApp;
